import type { SecurityEvent } from '@/types/security'

export function formatSecurityDate(value: string): string {
  return new Date(value).toLocaleString('pt-BR')
}

export function inspectionDetail(event: SecurityEvent): string | null {
  const meta = event.metadata
  if (!meta || typeof meta !== 'object') return null
  const parts: string[] = []
  if (typeof meta.inspectionType === 'string') parts.push(meta.inspectionType)
  if (typeof meta.detail === 'string') parts.push(meta.detail)
  if (typeof meta.route === 'string') parts.push(meta.route)
  return parts.length > 0 ? parts.join(' · ') : null
}

export function eventTypeLabel(event: SecurityEvent): string {
  const meta = event.metadata
  if (meta && typeof meta === 'object' && typeof meta.inspectionType === 'string') {
    return meta.inspectionType
  }
  return event.eventType
}

export function eventRouteLabel(event: SecurityEvent): string {
  const detail = inspectionDetail(event)
  if (detail && event.eventType === 'PORTAL_INSPECTION') return detail
  return `${event.method} ${event.path}`
}

export function severityClass(severity: string): string {
  const normalized = severity.toUpperCase()
  if (normalized === 'CRITICAL' || normalized === 'HIGH') {
    return 'bg-rose-500/10 text-rose-400 border-rose-500/20'
  }
  if (normalized === 'MEDIUM') {
    return 'bg-amber-500/10 text-amber-400 border-amber-500/10'
  }
  return 'bg-blue-500/10 text-blue-400 border-blue-500/10'
}

export function scoreClass(score: number): string {
  if (score >= 40) return 'bg-rose-500/20 text-rose-400'
  if (score >= 20) return 'bg-amber-500/20 text-amber-400'
  return 'bg-white/5 text-[var(--text-primary)]'
}
